import { Component } from 'react';
import { Modal, Button } from 'reactstrap'
import { Trans } from 'Helpers';

class ClearTeamModal extends Component {


  render() {
    const { isOpen, toggle, clearAll } = this.props;
    return (
      <Modal centered isOpen={isOpen} toggle={() => toggle(true)} className={`clearteam-modal center-modal insuf-coin`} size={'sm'}>
          <>
            <div className='text-center'><i className='icon-about'></i></div>
            <div className='head-insuf'><Trans>Confirm Team Clearance</Trans></div>
            <div className='clear-desc'>
              <h5><Trans>Are you sure you want to clear your team?</Trans></h5>
              <p><Trans>This action will remove all selected players from your current lineup. You will need to select your team again from scratch.</Trans></p>
            </div>
            <div className="alert-dialog-footer">
              <Button color="primary" className='btn-border' onClick={() => toggle()}><Trans>CANCEL</Trans></Button>
              <Button color="secondary" className='red-btn' onClick={() => clearAll()}><Trans>CLEAR TEAM</Trans></Button>
            </div>
          </>
      </Modal>
    )
  }
}
ClearTeamModal.defaultProps = {
  isOpen: false,
  toggle: () => { }
}
export default ClearTeamModal
